module.exports = __webpack_public_path__ + "img/yzg1.01298869.jpg";